import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import CardGrid from '@stories/Components/CardGrid/CardGrid';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import TitleAndIntroductionStyles from '@stories/Components/Misc/TitleAndIntroduction/TitleAndIntroduction.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${TitleAndIntroductionStyles.Container} {
    margin-bottom: ${fluid(24, 48)};
  }

  ${TitleAndIntroductionStyles.Introduction} {
    margin-bottom: 0;
  }
`;
const Wrapper = styled.div ``;
const FourColGrid = styled(CardGrid) `
  [data-has-carousel='true'] & {
    --itemPeek: 80px;
  }

  @media ${from(Device.MobileLarge)} {
    --rowItems: 2 !important; // Important required to prevent CLS specificity issue

    [data-alignment='left'] & {
      --alignment: flex-start;
    }
  }

  @media ${from(Device.TabletLarge)} {
    --rowItems: 3 !important;
  }

  @media ${from(Device.DesktopSmall)} {
    --rowItems: 4 !important;
  }
`;
const FlowchartStepstyles = {
    Container,
    Wrapper,
    FourColGrid,
};
export default FlowchartStepstyles;
